import {
  distinctUntilChanged,
  fromEvent,
  map,
  Observable,
  shareReplay,
  startWith,
} from 'rxjs';

/**
 * Observable of document visibility, updates when visibility changes.
 */
export const isVisible$ = fromEvent(document, 'visibilitychange').pipe(
  map(() => document.visibilityState === 'visible'),
  startWith(true),
  distinctUntilChanged(),
  shareReplay({ refCount: true, bufferSize: 1 })
);

export const fromIntersection = (
  element: Element,
  options?: IntersectionObserverInit
): Observable<boolean> =>
  new Observable((subscriber) => {
    const observer = new IntersectionObserver(
      (entries) => subscriber.next(entries.some((e) => e.isIntersecting)),
      options
    );
    observer.observe(element);
    return () => observer.disconnect();
  });
